import React, { useState, useEffect } from "react";
import { Container, Title } from "./styles";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import InputEdit from "../../components/InputEdit";
import RedButton from "../../components/RedButton";
import api from "../../services/api";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate, useParams } from "react-router-dom";

const EditarFormaPagamento = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [nomeFormaPagamento, setNomeFormaPagamento] = useState("");
  const [qtdParcelasFormaPagamento, setQtdParcelasFormaPagamento] =
    useState("");
  const [taxaFormaPagamento, setTaxaFormaPagamento] = useState("");

  useEffect(() => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");

    if (!token || role !== "ADMIN") {
      navigate("/login");
    }

    api.get(`/payments/${id}`).then((response) => {
      if (response.data) {
        setNomeFormaPagamento(response.data.nome || "");
        setQtdParcelasFormaPagamento(response.data.qtdParcelas || "");
        setTaxaFormaPagamento(response.data.taxa || "0");
      }
    });
  }, [navigate, id]);

  const handleDescricaoFormaPagamento = (event) => {
    setNomeFormaPagamento(event.target.value);
  };

  const handleQtdParcelasFormaPagamento = (event) => {
    setQtdParcelasFormaPagamento(event.target.value);
  };

  const handleTaxaFormaPagamento = (event) => {
    setTaxaFormaPagamento(event.target.value);
  };

  const formSubmit = (event) => {
    event.preventDefault();

    const qtdParcelasFormaPagamentoFormatado = parseInt(
      qtdParcelasFormaPagamento
    );

    const taxaFormaPagamentoFormatado = parseFloat(
      taxaFormaPagamento.replace(",", ".")
    );

    const data = {
      nome: nomeFormaPagamento,
      qtdParcelas: qtdParcelasFormaPagamentoFormatado,
      taxa: taxaFormaPagamentoFormatado,
    };

    api
      .put(`/payments/${id}`, data)
      .then((response) => {
        toast.success("Forma de pagamento alterada com sucesso!");
        navigate("/menuFormaPagamento");
      })
      .catch((error) => {
        console.error("Erro: ", error);
        if (error.response) {
          if (error.response.status === 404 || error.response.status === 400) {
            toast.warning(`${error.response.data.error}`);
          } else {
            toast.error(`${error.response.data.error}`);
          }
        } else {
          toast.error("Erro interno de servidor. Por favor, tente novamente!");
        }
      });
  };

  return (
    <Container>
      <MDBRow style={{ width: "100%", justifyContent: "center" }}>
        <MDBCol xg={6} lg={6} md={8} sm={12}>
          <form onSubmit={formSubmit}>
            <Title className="text-center">
              <h3>Editar pagamento no {nomeFormaPagamento}</h3>
            </Title>

            <MDBRow>
              <MDBCol md={6} className="text-start">
                <label>Descrição</label>
                <InputEdit
                  value={nomeFormaPagamento}
                  onChange={(event) => handleDescricaoFormaPagamento(event)}
                  password={false}
                />
              </MDBCol>
              <MDBCol md={3} className="text-start">
                <label>Qtd de parcelas</label>
                <InputEdit
                  value={qtdParcelasFormaPagamento}
                  onChange={(event) => handleQtdParcelasFormaPagamento(event)}
                  w
                  password={false}
                />
              </MDBCol>
              <MDBCol md={3} className="text-start">
                <label>Taxa</label>
                <InputEdit
                  value={taxaFormaPagamento}
                  onChange={(event) => handleTaxaFormaPagamento(event)}
                  password={false}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <RedButton onClick={() => navigate("/menuFormaPagamento")}>
                <strong>Voltar</strong>
              </RedButton>
              <RedButton onClick={formSubmit}>
                <strong>confirmar edição</strong>
              </RedButton>
            </MDBRow>
          </form>
        </MDBCol>
      </MDBRow>
    </Container>
  );
};

export default EditarFormaPagamento;
